<template>
    <div class="grid-container grid-container--small mb--2rem">
      <div class="grid-x js--insertMobileTooltip">
        <div class="small-12 cell of--visible">
    
      <h2 :class="{'text-center': center}"><slot></slot></h2>
      <div class="mt-3">
      <p><slot name="subtext"></p>
      </div>
      </div>
    </div>
 </div>
</template>

<script>
export default {
  props: {
    title: String,
    center: {
      default: 0,
    }
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = this._uid;
    if(typeof this.align != 'undefined'){
      this.center = 1
    }

  },
};
</script>

<style lang="scss">
.tooltip {
  margin-left: 1rem;
}
</style>
